import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { CollectionSort } from "@/entities/IProfile";
import { ApiXTdhTokensPage } from "@/generated/models/ApiXTdhTokensPage";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
interface UseXtdhTokensQueryProps {
  readonly identity: string;
  readonly page: number;
  readonly pageSize: number;
  readonly sort: string;
  readonly order: string;
  readonly contract?: string | null;
}
export const useXtdhTokensQuery = t0 => {
  const $ = _c(7);
  const {
    identity,
    page,
    pageSize,
    sort,
    order,
    contract
  } = t0;
  let t1;
  if ($[0] !== contract || $[1] !== identity || $[2] !== order || $[3] !== page || $[4] !== pageSize || $[5] !== sort) {
    t1 = {
      queryKey: [QueryKey.XTDH_TOKENS, identity, page, pageSize, sort, order, contract],
      queryFn: async () => {
        let apiSort = sort;
        if (sort === CollectionSort.XTDH) {
          apiSort = "xtdh";
        } else {
          if (sort === CollectionSort.XTDH_DAY) {
            apiSort = "xtdh_rate";
          }
        }
        const params = {
          identity,
          page: page.toString(),
          page_size: pageSize.toString(),
          sort: apiSort,
          order
        };
        if (contract) {
          params.contract = contract;
        }
        return await commonApiFetch({
          endpoint: "xtdh/tokens",
          params
        });
      },
      placeholderData: keepPreviousData
    };
    $[0] = contract;
    $[1] = identity;
    $[2] = order;
    $[3] = page;
    $[4] = pageSize;
    $[5] = sort;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return useQuery(t1);
};